import DynamicTable from '@atlaskit/dynamic-table';
import React from 'react';
import { formatAmount } from "../../PricingTab.utils";
import { PricingTierAmount as Amount, PricingTierList as List, PricingTierListItem as Item, PricingTierListItemContent as Content, PricingTierRecurrence as Recurrence, PricingTierTableAmountCell as AmountCell, PricingTierTableCell as UnitCell, RemoteAgentTierItemHeader as Header, RemoteAgentTierItemUnitText as TierItemText } from "../PricingTiers.styles";
export const RemoteAgentTierUnit = ({
  item
}) => {
  if (item.floor === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TierItemText, null, "Local agents only"), /*#__PURE__*/React.createElement(TierItemText, null, "10 jobs"));
  }
  if (item.floor === 1) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TierItemText, null, "1 remote agent"), /*#__PURE__*/React.createElement(TierItemText, null, "Unlimited jobs"));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TierItemText, null, item.floor, "-", item.ceiling, " remote agents"), /*#__PURE__*/React.createElement(TierItemText, null, "Unlimited jobs"));
};
const TABLE_HEADER = [{
  isSortable: false,
  key: 'ceiling',
  content: 'Agents'
}, {
  isSortable: false,
  key: 'amount',
  content: /*#__PURE__*/React.createElement(AmountCell, null, "Annual Price")
}];
const getRows = (items, currency) => {
  return items.map(item => {
    const teamSize = {
      content: /*#__PURE__*/React.createElement(UnitCell, null, /*#__PURE__*/React.createElement(RemoteAgentTierUnit, {
        item: item
      }))
    };
    const annualPrice = {
      content: /*#__PURE__*/React.createElement(AmountCell, null, formatAmount(item.amount, {
        currency
      }))
    };
    return {
      cells: [teamSize, annualPrice]
    };
  });
};

/**
 * Pricing tier grid for tierType=REMOTE_AGENT_TIERED
 * Applicable for Bamboo apps only
 */
export const RemoteAgentTierGrid = props => {
  const {
    items,
    currency
  } = props;
  return /*#__PURE__*/React.createElement(List, null, items.map((item, index) => {
    const amount = item.amount > 0 ? formatAmount(item.amount, {
      currency
    }) : 'Free';
    return (
      /*#__PURE__*/
      // using index as a key since the list is static
      React.createElement(Item, {
        key: index
      }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(RemoteAgentTierUnit, {
        item: item
      })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Amount, null, amount), /*#__PURE__*/React.createElement(Recurrence, null, "per year")))
    );
  }));
};

/**
 * Pricing tier table for tierType=REMOTE_AGENT_TIERED
 * Applicable for Bamboo apps only
 */
export const RemoteAgentTiersTable = props => {
  const {
    items,
    currency
  } = props;
  return /*#__PURE__*/React.createElement(DynamicTable, {
    head: {
      cells: TABLE_HEADER
    },
    rows: getRows(items, currency)
  });
};